import { useState } from 'react';
export const useDataGrid = (layoutType) => {
    const [activeSidebar, setActiveSidebar] = useState('');
    const toggleSideMenu = (sideBar) => () => {
        activeSidebar === sideBar ? setActiveSidebar('') : setActiveSidebar(sideBar);
    };
    return { activeSidebar, toggleSideMenu, layoutType };
};
